import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';
import { TrashIcon } from '@heroicons/react/24/outline';
import ComboboxAutocomplete from './combobox_autocomplete';
import { listOrganizationalUnits } from '../services/api_org_unit';

const PairOrgUnit = ({ onSelectOrganizationalUnit, selectedOU, creatingDS, creatingWWH }) => {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(selectedOU || null);

  useEffect(() => {
    setSelectedUnit(selectedOU);
  }, [selectedOU]);
  

  useEffect(() => {
    async function fetchUnits() {
      try {
        const unitsData = await listOrganizationalUnits(token, true);
        setUnits(unitsData.data);
      } catch (error) {
        console.error('Error fetching units:', error);
        setError('Errore durante il caricamento delle unità organizzative.');
      }
    }
    fetchUnits();
  }, [token]);

  const handleSelectUnit = (selected) => {
    setSelectedUnit(selected);
    if (onSelectOrganizationalUnit) {
      onSelectOrganizationalUnit(selected);
    }
  };

  const handleDeleteSelectedUnit = () => {
    setSelectedUnit(null);
    if (onSelectOrganizationalUnit) {
      onSelectOrganizationalUnit(null);
    }
  };

  if (creatingWWH) {
    return null;
  }

  return (
    <div className="border border-solid-2 border-gray-200 shadow-md rounded-md my-5 bg-white">
      <div className="grid grid-cols-1 mx-4 mt-4">
        {!selectedUnit ? (
          <div className="my-3 pb-5 bg-white w-full" style={{ zIndex: '25' }}>
            <h2 className="text-sm font-medium text-gray-700 mb-2 uppercase text-left">
              {creatingDS
                ? 'Seleziona unità organizzativa da associare al turno'
                : 'Seleziona unità organizzativa da associare alla fascia oraria giornaliera'}
            </h2>
            <h3 className="text-xs font-normal text-gray-700 mb-2 text-left">
              {creatingDS
                ? 'Non effettuando la selezione, il turno sarà disponibile per i dipendenti che non sono assegnati ad alcuna unità.'
                : 'Selezionando l\'unità, il conteggio delle ore del turno verrà incluso nel totale delle ore assegnate sulla specifica unità.'}
            </h3>
            <div className='border border-gray-200 rounded-lg'>
              <ComboboxAutocomplete
                options={units}
                bgActiveColor="bg-indigo-100"
                textActiveColor="text-gray-900"
                placeholder="Seleziona Unità Organizzativa..."
                onChange={handleSelectUnit}
                value={selectedUnit}
                positionOptions="absolute"
              />
            </div>
          </div>
        ) : (
          <div className="mb-4 flex justify-between items-center bg-gray-50 p-3 rounded-md">
            <span className="text-sm font-medium text-gray-700 uppercase">
              Unità selezionata: <span className="font-normal text-gray-500">{selectedUnit.name}</span>
            </span>
            <button
              className="text-gray-700 font-bold px-1"
              title="Elimina"
              onClick={handleDeleteSelectedUnit}
            >
              <TrashIcon className="h-6 w-6 hover:text-red-500" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PairOrgUnit;
